import React from 'react';
import { Phone, MapPin, Facebook } from 'lucide-react';
import { PHONE_TEL, GOOGLE_MAPS_URL, FACEBOOK_URL } from '../constants/business';
export function MobileStickyBar() {
  return <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-brand-hunter text-brand-offwhite z-40 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] pb-safe" data-id="element-112">
      <div className="flex items-center justify-between px-2 py-2" data-id="element-113">
        <a href={PHONE_TEL} className="flex-1 flex flex-col items-center justify-center py-2 border-r border-brand-offwhite/20" data-id="element-114">
          <Phone className="w-5 h-5 mb-1" data-id="element-115" />
          <span className="text-[10px] font-medium uppercase tracking-wider" data-id="element-116">
            Call
          </span>
        </a>
        <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="flex-1 flex flex-col items-center justify-center py-2 border-r border-brand-offwhite/20" data-id="element-117">
          <MapPin className="w-5 h-5 mb-1" data-id="element-118" />
          <span className="text-[10px] font-medium uppercase tracking-wider" data-id="element-119">
            Directions
          </span>
        </a>
        <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" className="flex-1 flex flex-col items-center justify-center py-2" data-id="element-120">
          <Facebook className="w-5 h-5 mb-1" data-id="element-121" />
          <span className="text-[10px] font-medium uppercase tracking-wider" data-id="element-122">
            Facebook
          </span>
        </a>
      </div>
    </div>;
}